export var MandatoryAreaSearchState;
(function (MandatoryAreaSearchState) {
    MandatoryAreaSearchState["DISABLED"] = "disabled";
    MandatoryAreaSearchState["ENABLED"] = "enabled";
    MandatoryAreaSearchState["LOCATION_SET"] = "location-set";
})(MandatoryAreaSearchState || (MandatoryAreaSearchState = {}));
